import {
  ParagraphText,
  StackLayout,
  TextAction,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';
import { EXTERNAL_LINKS } from 'common/links';

export const SignInFooter = () => {
  const { formatMessage } = useIntl();

  return (
    <StackLayout
      horizontalAlignment="center"
      css={{ position: 'relative', marginTop: '$two', width: '100%' }}
    >
      <ParagraphText size="sm" css={{ fontWeight: 'bold' }}>
        {formatMessage({ id: 'STR_LANDING_PAGE_DONT_HAVE_ACCOUNT' })}
      </ParagraphText>
      <TextAction
        href={APP_MANAGED_ROUTES.SIGN_IN}
        size="medium"
        css={{
          textDecoration: 'underline',
        }}
      >
        {formatMessage({ id: 'STR_LANDING_PAGE_REGISTER_NOW' })}
      </TextAction>
      <StackLayout
        horizontalAlignment="center"
        css={{
          position: 'absolute',
          marginTop: '$five',
          '@mobile': { marginTop: '$two', position: 'inherit' },
          '@mobileLandscape': { marginTop: '$two', position: 'inherit' },
        }}
      >
        <ParagraphText size="sm">
          <TextAction
            href={EXTERNAL_LINKS.PRIVACY}
            size="medium"
            css={{
              textDecoration: 'underline',
            }}
          >
            {formatMessage({ id: 'STR_PRIVACY_POLICY' })}
          </TextAction>
          {` ${formatMessage({ id: 'STR_AND' })} `}
          <TextAction
            href={EXTERNAL_LINKS.TERMS}
            size="medium"
            css={{
              textDecoration: 'underline',
            }}
          >
            {formatMessage({ id: 'STR_TERMS_OF_SERVICE' })}
          </TextAction>
        </ParagraphText>
      </StackLayout>
    </StackLayout>
  );
};
